import { render, staticRenderFns } from "./modal-board-copy.vue?vue&type=template&id=531d011f&scoped=true&"
import script from "./modal-board-copy.vue?vue&type=script&lang=ts&"
export * from "./modal-board-copy.vue?vue&type=script&lang=ts&"
import style0 from "./modal-board-copy.vue?vue&type=style&index=0&id=531d011f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531d011f",
  null
  
)

/* custom blocks */
import block0 from "./modal-board-copy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports